import React, { Component } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { setUser } from '../../actions';
import withBackend from '../../backend/withBackend';
import BillingPage from '../../components/BillingPage';

class BillingPageContainer extends Component {
  render() {
    const { firebase, setUser } = this.props;
    return <BillingPage firebase={firebase} setUser={setUser} />;
  }
}

export default compose(
  connect(null, { setUser }),
  withBackend
)(BillingPageContainer);
